export const CALL_NUMBER = "8910753380";
export const WHATSAPP_NUMBER = "918282941060";
export const OFFER_MARKUP = { events: 900, cleaning: 199, garden: 180 };
export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const U = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=900&q=80`;

export const categories = [
  {
    id: "garden",
    name: "Garden & Plant Care",
    nameBn: "বাগান ও গাছের যত্ন",
    tagline: "Mali service, plant doctor & balcony/roof garden setup",
    taglineBn: "মালি সার্ভিস, প্ল্যান্ট ডাক্তার ও ব্যালকনি/ছাদ বাগান সেটআপ",
    image: "/assets/category-garden.png",
    accent: "#4A7C59",
    target: "#garden",
  },
  {
    id: "events",
    name: "Surprise Event Management",
    nameBn: "সারপ্রাইজ ইভেন্ট ম্যানেজমেন্ট",
    tagline: "Birthdays, anniversaries, proposals & more — at home or riverside",
    taglineBn: "জন্মদিন, অ্যানিভার্সারি, প্রোপোজাল আর আরও অনেক কিছু — ঘরে বা নদীর ধারে",
    image: "/assets/event-proposal.jpg",
    accent: "#E85D75",
    target: "#events",
  },
  {
    id: "cleaning",
    name: "Cleaning Services",
    nameBn: "ক্লিনিং সার্ভিসেস",
    tagline: "Sofa, carpet, kitchen, windows & full home cleaning",
    taglineBn: "সোফা, কার্পেট, কিচেন, জানালা ও পুরো বাড়ির ক্লিনিং",
    image: "/assets/category-cleaning.png",
    accent: "#457B9D",
    target: "#cleaning",
  },
];

export const EVENT_LOCATIONS = ["At Home", "Raipur Riverside", "Burul Riverside"];
export const HOME_LOCATIONS = ["At Home"];

const OCCASION_INCLUDES = ["Full decoration", "Flower bouquet", "Cake", "Food for 3–5 people", "Crackers / fireworks"];
const OCCASION_INCLUDES_BN = ["পুরো ডেকোরেশন", "ফুলের তোড়া", "কেক", "৩–৫ জনের খাবার", "আতশবাজি / ফায়ারওয়ার্কস"];

const OCCASION_PACKAGES = [
  { label: "Home Surprise — Without Cameraman", labelBn: "হোম সারপ্রাইজ — ক্যামেরাম্যান ছাড়া", price: 4999 },
  { label: "Home Surprise — With Cameraman", labelBn: "হোম সারপ্রাইজ — ক্যামেরাম্যান সহ", price: 6999 },
  { label: "Riverside (Garden / Resort) — Basic", labelBn: "রিভারসাইড (গার্ডেন / রিসোর্ট) — বেসিক", price: 4999 },
  { label: "Riverside (Garden / Resort) — Classic", labelBn: "রিভারসাইড (গার্ডেন / রিসোর্ট) — ক্লাসিক", price: 6999 },
  { label: "Riverside (Garden / Resort) — Premium", labelBn: "রিভারসাইড (গার্ডেন / রিসোর্ট) — প্রিমিয়াম", price: 8999 },
  { label: "Riverside (Garden / Resort) — Royal", labelBn: "রিভারসাইড (গার্ডেন / রিসোর্ট) — রয়্যাল", price: 10999 },
  { label: "AC Room (Add-on)", labelBn: "এসি রুম (অ্যাড-অন)", price: 3500 },
];

const occasionFields = {
  includes: OCCASION_INCLUDES,
  includesBn: OCCASION_INCLUDES_BN,
  packages: OCCASION_PACKAGES,
  priceLabel: "From ₹4,999",
  priceLabelBn: "শুরু ₹৪,৯৯৯",
};

export const eventServices = [
  {
    id: "birthday-surprise",
    name: "Birthday Surprise",
    nameBn: "জন্মদিনের সারপ্রাইজ",
    desc: "Theme decoration, balloons, cake table and a full surprise setup for all ages.",
    descBn: "সব বয়সের জন্য থিম ডেকোরেশন, বেলুন, কেক টেবিল আর পুরো সারপ্রাইজ সেটআপ।",
    image: "/assets/event-birthday.jpg",
    ...occasionFields,
  },
  {
    id: "anniversary-surprise",
    name: "Anniversary Surprise",
    nameBn: "অ্যানিভার্সারি সারপ্রাইজ",
    desc: "Romantic room or riverside setup with flowers, candles, photos and lights.",
    descBn: "ফুল, মোমবাতি, ছবি আর আলো দিয়ে রোমান্টিক ঘর বা নদীর ধারের সেটআপ।",
    image: "/assets/event-proposal.jpg",
    ...occasionFields,
  },
  {
    id: "proposal-setup",
    name: "Proposal Setup",
    nameBn: "প্রোপোজাল সেটআপ",
    desc: "A picture-perfect proposal scene — marquee letters, petals, candles and music.",
    descBn: "ছবির মতো প্রোপোজাল দৃশ্য — মারকি লেটার, গোলাপপাপড়ি, মোমবাতি আর গান।",
    image: "/assets/event-proposal.png",
    ...occasionFields,
  },
  {
    id: "first-night-decoration",
    name: "First Night Bed Decoration",
    nameBn: "ফুলশয্যা সাজানো",
    desc: "Elegant floral bed decoration with fresh flowers, drapes and soft lighting.",
    descBn: "তাজা ফুল, পর্দা আর মৃদু আলোয় এলেগ্যান্ট বিছানা সাজানো।",
    image: "/assets/event-firstnight.png",
    includes: ["Bed decoration", "Fresh / aesthetic flowers", "Balloon & decorative setup", "Bedside decoration", "Romantic theme setup"],
    includesBn: ["বেড ডেকোরেশন", "তাজা / এস্থেটিক ফুল", "বেলুন ও ডেকোরেটিভ সেটআপ", "বেডসাইড ডেকোরেশন", "রোমান্টিক থিম সেটআপ"],
    packages: [
      { label: "Classic", labelBn: "ক্লাসিক", price: 2299 },
      { label: "Premium", labelBn: "প্রিমিয়াম", price: 3500 },
      { label: "Royal", labelBn: "রয়্যাল", price: 5049 },
    ],
    priceLabel: "From ₹2,299",
    priceLabelBn: "শুরু ₹২,২৯৯",
  },
  {
    id: "wedding-tattwa",
    name: "Wedding Tattwa Decoration",
    nameBn: "বিয়ের তত্ত্ব সাজানো",
    desc: "Traditional tattwa tray and stage decoration for Bengali weddings.",
    descBn: "বাঙালি বিয়ের জন্য ঐতিহ্যবাহী তত্ত্ব ট্রে ও স্টেজ ডেকোরেশন।",
    image: "/assets/event-tattwa.png",
    includes: ["Tattwa tray decoration", "Flower decoration", "Decorative elements", "Traditional wedding theme setup", "Basic delivery & setup"],
    includesBn: ["তত্ত্ব ট্রে ডেকোরেশন", "ফুলের সাজানো", "ডেকোরেটিভ এলিমেন্টস", "ঐতিহ্যবাহী বিয়ের থিম সেটআপ", "বেসিক ডেলিভারি ও সেটআপ"],
    packages: [
      { label: "Classic", labelBn: "ক্লাসিক", price: 2999 },
      { label: "Premium", labelBn: "প্রিমিয়াম", price: 4999 },
    ],
    priceLabel: "From ₹2,999",
    priceLabelBn: "শুরু ₹২,৯৯৯",
  },
  {
    id: "fathers-day",
    name: "Father's Day Surprise",
    nameBn: "ফাদার্স ডে সারপ্রাইজ",
    desc: "A heartfelt surprise setup with gifts, photos and decor to celebrate Baba.",
    descBn: "বাবার জন্য উপহার, ছবি আর ডেকোর দিয়ে আন্তরিক সারপ্রাইজ সেটআপ।",
    image: "/assets/event-fathersday.jpg",
    ...occasionFields,
  },
  {
    id: "mothers-day",
    name: "Mother's Day Surprise",
    nameBn: "মাদার্স ডে সারপ্রাইজ",
    desc: "Fresh flowers, personalised touches and warm decor to make Maa smile.",
    descBn: "তাজা ফুল, ব্যক্তিগত ছোঁয়া আর উষ্ণ ডেকোরে মাকে হাসান।",
    image: "/assets/event-mothersday.jpg",
    ...occasionFields,
  },
  {
    id: "teachers-day",
    name: "Teachers Day Surprise",
    nameBn: "টিচার্স ডে সারপ্রাইজ",
    desc: "Classroom or home surprise decoration to honour your favourite teacher.",
    descBn: "প্রিয় শিক্ষককে সম্মান জানাতে ক্লাসরুম বা বাড়িতে সারপ্রাইজ ডেকোরেশন।",
    image: "/assets/event-teachersday.png",
    ...occasionFields,
  },
  {
    id: "valentines-day",
    name: "Valentine's Day Surprise",
    nameBn: "ভ্যালেন্টাইনস ডে সারপ্রাইজ",
    desc: "Roses, balloons, gift hampers and full romantic setups for the day of love.",
    descBn: "ভালোবাসার দিনে গোলাপ, বেলুন, গিফট হ্যাম্পার আর পুরো রোমান্টিক সেটআপ।",
    image: "/assets/event-valentines.png",
    includes: OCCASION_INCLUDES,
    includesBn: OCCASION_INCLUDES_BN,
    packages: [
      ...OCCASION_PACKAGES,
      { label: "Resort + AC Room + Decoration — Classic", labelBn: "রিসোর্ট + এসি রুম + ডেকোরেশন — ক্লাসিক", price: 5559 },
      { label: "Resort + AC Room + Decoration — Premium", labelBn: "রিসোর্ট + এসি রুম + ডেকোরেশন — প্রিমিয়াম", price: 6999 },
    ],
    priceLabel: "From ₹4,999",
    priceLabelBn: "শুরু ₹৪,৯৯৯",
  },
  {
    id: "photographer",
    name: "Photographer",
    nameBn: "ফটোগ্রাফার",
    desc: "Professional photographer for your event — candid and posed coverage.",
    descBn: "আপনার অনুষ্ঠানের জন্য প্রফেশনাল ফটোগ্রাফার — ক্যান্ডিড ও পোজড কভারেজ।",
    image: U("photo-1516035069371-29a1b244cc32"),
    packages: [{ label: "Cameraman (Full Event)", labelBn: "ক্যামেরাম্যান (পুরো অনুষ্ঠান)", price: 2999 }],
    note: "Photos delivered via album or pen drive.",
    noteBn: "অ্যালবাম বা পেনড্রাইভের মাধ্যমে ফটো দেওয়া হবে।",
    priceLabel: "₹2,999",
    priceLabelBn: "₹২,৯৯৯",
  },
  {
    id: "photography-package",
    name: "Photography Package",
    nameBn: "ফটোগ্রাফি প্যাকেজ",
    desc: "Full event coverage package with edited photos delivered to you.",
    descBn: "এডিট করা ছবিসহ পুরো অনুষ্ঠানের কভারেজ প্যাকেজ।",
    image: U("photo-1554080353-a576cf803bda"),
    price: null,
  },
  {
    id: "album-package",
    name: "Album Package",
    nameBn: "অ্যালবাম প্যাকেজ",
    desc: "Premium printed photo album to keep your memories forever.",
    descBn: "স্মৃতি চিরদিনের জন্য রেখে দিতে প্রিমিয়াম প্রিন্টেড ফটো অ্যালবাম।",
    image: U("photo-1492724441997-5dc865305da7"),
    price: null,
  },
  {
    id: "drone-shoot",
    name: "Drone Shoot Photography",
    nameBn: "ড্রোন শুট ফটোগ্রাফি",
    desc: "Stunning aerial drone shots of your event and riverside setups.",
    descBn: "আপনার অনুষ্ঠান ও নদীর ধারের সেটআপের দারুণ এরিয়াল ড্রোন শট।",
    image: U("photo-1507582020474-9a35b7d455d9"),
    packages: [{ label: "Drone Shoot", labelBn: "ড্রোন শুট", price: 3999 }],
    priceLabel: "₹3,999",
    priceLabelBn: "₹৩,৯৯৯",
  },
];

export const cleaningServices = [
  {
    id: "sofa-cleaning",
    name: "Sofa Cleaning",
    nameBn: "সোফা ক্লিনিং",
    image: "/assets/clean-sofa.jpg",
    detail: "Deep shampoo cleaning, vacuum and stain treatment for every seat.",
    detailBn: "প্রতিটি সিটে ডিপ শ্যাম্পু ক্লিনিং, ভ্যাকুয়াম ও দাগ তোলা।",
    groups: [
      {
        title: "Sofa Cleaning",
        titleBn: "সোফা ক্লিনিং",
        items: [
          { label: "3-Seater", labelBn: "৩-সিটার", price: 329 },
          { label: "4-Seater", labelBn: "৪-সিটার", price: 399 },
          { label: "5-Seater", labelBn: "৫-সিটার", price: 499 },
          { label: "6-Seater", labelBn: "৬-সিটার", price: 599 },
          { label: "7-Seater", labelBn: "৭-সিটার", price: 699 },
          { label: "8-Seater", labelBn: "৮-সিটার", price: 799 },
          { label: "9-Seater", labelBn: "৯-সিটার", price: 799 },
          { label: "10-Seater", labelBn: "১০-সিটার", price: 999 },
          { label: "Cushions (5 pcs)", labelBn: "কুশন (৫ পিস)", price: 199 },
        ],
      },
      {
        title: "Sofa Cum Bed",
        titleBn: "সোফা কাম বেড",
        items: [
          { label: "1-Seater", labelBn: "১-সিটার", price: 349 },
          { label: "2-Seater", labelBn: "২-সিটার", price: 599 },
          { label: "3-Seater", labelBn: "৩-সিটার", price: 849 },
        ],
      },
    ],
  },
  {
    id: "carpet-cleaning",
    name: "Carpet Cleaning",
    nameBn: "কার্পেট ক্লিনিং",
    image: "/assets/clean-carpet.jpg",
    detail: "Deep wash and dust removal by carpet size.",
    detailBn: "সাইজ অনুযায়ী ডিপ ওয়াশ ও ধুলো তোলা।",
    groups: [
      {
        title: "Carpet Cleaning",
        titleBn: "কার্পেট ক্লিনিং",
        items: [
          { label: "Up to 25 sq ft", labelBn: "২৫ বর্গফুট পর্যন্ত", price: 349 },
          { label: "25 – 50 sq ft", labelBn: "২৫–৫০ বর্গফুট", price: 499 },
          { label: "50 – 100 sq ft", labelBn: "৫০–১০০ বর্গফুট", price: 749 },
          { label: "100 – 150 sq ft", labelBn: "১০০–১৫০ বর্গফুট", price: 899 },
          { label: "150 – 200 sq ft", labelBn: "১৫০–২০০ বর্গফুট", price: 1149 },
        ],
      },
    ],
  },
  {
    id: "mattress-cleaning",
    name: "Mattress Cleaning",
    nameBn: "ম্যাট্রেস ক্লিনিং",
    image: U("photo-1505693416388-ac5ce068fe85"),
    detail: "Dust-mite removal, shampooing and sanitisation.",
    detailBn: "ডাস্ট-মাইট দূর করা, শ্যাম্পু ও স্যানিটাইজেশন।",
    groups: [
      {
        title: "Mattress Cleaning",
        titleBn: "ম্যাট্রেস ক্লিনিং",
        items: [
          { label: "Single Bed", labelBn: "সিঙ্গেল বেড", price: 349 },
          { label: "Double Bed", labelBn: "ডাবল বেড", price: 549 },
        ],
      },
    ],
  },
  {
    id: "kitchen-cleaning",
    name: "Kitchen Cleaning",
    nameBn: "কিচেন ক্লিনিং",
    image: "/assets/clean-kitchen.jpg",
    detail: "Degreasing and deep cleaning of cabinets, slabs and tiles.",
    detailBn: "ক্যাবিনেট, স্ল্যাব ও টাইলসের গ্রীজ উঠিয়ে ডিপ ক্লিনিং।",
    groups: [
      {
        title: "Kitchen Cleaning",
        titleBn: "কিচেন ক্লিনিং",
        items: [
          { label: "Cabinet Exterior Only", labelBn: "শুধু ক্যাবিনেটের বাইরে", price: 899 },
          { label: "Cabinet Exterior & Interior", labelBn: "ক্যাবিনেট বাইরে ও ভেতরে", price: 1799 },
        ],
      },
    ],
  },
  {
    id: "bedroom-cleaning",
    name: "Bedroom Cleaning",
    nameBn: "বেডরুম ক্লিনিং",
    image: U("photo-1595526114035-0d45ed16cfbf"),
    detail: "Full bedroom deep cleaning — dusting, floor, furniture and fittings.",
    detailBn: "পুরো বেডরুম ডিপ ক্লিনিং — ঝাড়পোঁছ, মেঝে, ফার্নিচার ও ফিটিংস।",
    groups: [
      {
        title: "Bedroom Cleaning",
        titleBn: "বেডরুম ক্লিনিং",
        items: [{ label: "Bedroom Deep Cleaning", labelBn: "বেডরুম ডিপ ক্লিনিং", price: 899 }],
      },
    ],
  },
  {
    id: "living-room-cleaning",
    name: "Living Room Cleaning",
    nameBn: "লিভিং রুম ক্লিনিং",
    image: U("photo-1586023492125-27b2c045efd7"),
    detail: "Complete living room cleaning including furniture, fans and floors.",
    detailBn: "ফার্নিচার, ফ্যান ও মেঝেসহ পুরো লিভিং রুম ক্লিনিং।",
    groups: [
      {
        title: "Living Room Cleaning",
        titleBn: "লিভিং রুম ক্লিনিং",
        items: [{ label: "Living Room Deep Cleaning", labelBn: "লিভিং রুম ডিপ ক্লিনিং", price: 999 }],
      },
    ],
  },
  {
    id: "window-cleaning",
    name: "Window Cleaning",
    nameBn: "উইন্ডো ক্লিনিং",
    image: "/assets/clean-window.jpg",
    detail: "Includes grill, channel and glass cleaning.",
    detailBn: "গ্রিল, চ্যানেল ও কাচ পরিষ্কারসহ।",
    groups: [
      {
        title: "Window Cleaning",
        titleBn: "উইন্ডো ক্লিনিং",
        items: [
          { label: "Window (grill, channel, with glass)", labelBn: "জানালা (গ্রিল, চ্যানেল, কাচসহ)", price: 380 },
        ],
      },
    ],
  },
  {
    id: "wall-wash-cleaning",
    name: "Wall Wash Cleaning",
    nameBn: "ওয়াল ওয়াশ ক্লিনিং",
    image: "/assets/clean-wallwash.jpg",
    detail: "Gentle wall wash that lifts dust, stains and marks.",
    detailBn: "ধুলো, দাগ ও ছাপ আলতো করে তুলে ফেলা দেয়াল ধোয়া।",
    groups: [
      {
        title: "Wall Wash Cleaning",
        titleBn: "ওয়াল ওয়াশ ক্লিনিং",
        items: [
          { label: "Wall Wash (120 sq ft wall)", labelBn: "ওয়াল ওয়াশ (১২০ বর্গফুট দেয়াল)", price: 999 },
        ],
      },
    ],
  },
];

export const gardenServices = [
  {
    id: "regular-plant-care",
    name: "Regular Plant Care (Mali Service)",
    nameBn: "নিয়মিত গাছের যত্ন (মালি সার্ভিস)",
    desc: "Scheduled watering, pruning, soil care and repotting for home gardens.",
    descBn: "বাড়ির বাগানের জন্য নির্ধারিত জল দেওয়া, ছাঁটাই, মাটি দেখাশোনা ও রিপটিং।",
    image: "/assets/regular-plant-care.webp",
    includes: [
      "Watering the plants",
      "Cutting dry leaves & branches",
      "Basic pruning & trimming",
      "Loosening pot soil",
      "Weed removal",
      "Cleaning pots & surrounding area",
      "Pest / disease check",
      "Fixing plant placement",
      "General plant health check",
    ],
    includesBn: [
      "গাছে জল দেওয়া",
      "শুকনো পাতা ও ডাল কাটা",
      "বেসিক প্রুনিং ও ট্রিমিং",
      "টবের মাটি আলগা করা",
      "আগাছা পরিষ্কার",
      "টব ও আশেপাশের জায়গা পরিষ্কার",
      "গাছের পেস্ট / রোগ চেক",
      "গাছের অবস্থান ঠিক করা",
      "গাছের সাধারণ হেলথ চেক",
    ],
    packages: [
      { label: "1–10 plants (1 hr)", labelBn: "১–১০টা গাছ (১ ঘণ্টা)", price: 399 },
      { label: "11–15 plants (1.5 hrs)", labelBn: "১১–১৫টা গাছ (দেড় ঘণ্টা)", price: 499 },
      { label: "15–30 plants (2 hrs)", labelBn: "১৫–৩০টা গাছ (২ ঘণ্টা)", price: 649 },
      { label: "31–40 plants (2.5 hrs)", labelBn: "৩১–৪০টা গাছ (আড়াই ঘণ্টা)", price: 899 },
      { label: "41–50 plants (3 hrs)", labelBn: "৪১–৫০টা গাছ (৩ ঘণ্টা)", price: 1159 },
    ],
    extraNote: "More than 50 plants: ₹40 added per extra plant.",
    extraNoteBn: "৫০টার বেশি গাছ হলে অতিরিক্ত প্রতি গাছে ₹৪০ করে যোগ হবে।",
    priceLabel: "From ₹399",
    priceLabelBn: "শুরু ₹৩৯৯",
  },
  {
    id: "monthly-plant-care",
    name: "Monthly Plant Care Service",
    nameBn: "মাসিক প্ল্যান্ট কেয়ার সার্ভিস",
    desc: "Complete monthly care — our gardener visits 4 times a month to look after every plant.",
    descBn: "পুরো মাসের যত্ন — আমাদের মালি মাসে ৪বার গিয়ে প্রতিটি গাছের দেখাশোনা করবেন।",
    image: "/assets/monthly-plant-care.webp",
    includes: [
      "Watering the plants",
      "Cutting dry leaves & branches",
      "Loosening pot soil",
      "Weed removal",
      "Cleaning pots & surrounding area",
      "Pest / disease check",
      "Fixing plant placement",
      "Applying fertilizer, nutrition & pesticides",
      "General plant health check",
    ],
    includesBn: [
      "গাছে জল দেওয়া",
      "শুকনো পাতা ও ডাল কাটা",
      "টবের মাটি আলগা করা",
      "আগাছা পরিষ্কার",
      "টব ও আশেপাশের জায়গা পরিষ্কার",
      "গাছের পেস্ট / রোগ চেক",
      "গাছের অবস্থান ঠিক করা",
      "গাছে সার, খাবার, বিষ (পেস্টিসাইড) দেওয়া",
      "গাছের সাধারণ হেলথ চেক",
    ],
    packages: [
      { label: "1–25 plants (4 visits / month)", labelBn: "১–২৫টা গাছ (মাসে ৪বার)", price: 1600 },
      { label: "25–35 plants (4 visits / month)", labelBn: "২৫–৩৫টা গাছ (মাসে ৪বার)", price: 2400 },
    ],
    priceLabel: "From ₹1,600 / month",
    priceLabelBn: "শুরু ₹১,৬০০ / মাস",
  },
  {
    id: "plant-doctor",
    name: "Plant Doctor / Plant Health Check",
    nameBn: "প্ল্যান্ট ডাক্তার / হেলথ চেক",
    desc: "Check-up for sick plants — yellow leaves, rot, stunted growth and more.",
    descBn: "অসুস্থ গাছের পরীক্ষা — পাতা হলুদ, পচে যাওয়া, বৃদ্ধি না হওয়া ইত্যাদি।",
    price: 599,
    image: "/assets/plant-doctor.webp",
    packages: [{ label: "Plant Health Check (per visit)", labelBn: "প্ল্যান্ট হেলথ চেক (প্রতি ভিজিট)", price: 599 }],
    priceLabel: "₹599 / visit",
    priceLabelBn: "₹৫৯৯ / ভিজিট",
  },
  {
    id: "balcony-garden",
    name: "Balcony Garden Setup",
    nameBn: "ব্যালকনি গার্ডেন সেটআপ",
    desc: "Complete design and setup of balcony gardens, pots to plants.",
    descBn: "টব থেকে গাছ — ব্যালকনি বাগানের পুরো ডিজাইন ও সেটআপ।",
    price: 1499,
    image: "https://images.pexels.com/photos/9721356/pexels-photo-9721356.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    includes: ["Space inspection", "Plant arrangement", "Soil planning", "Basic setup"],
    includesBn: ["স্পেস ইনসপেকশন", "গাছের বিন্যাস", "মাটির পরিকল্পনা", "বেসিক সেটআপ"],
    packages: [{ label: "Balcony Garden Setup (Basic)", labelBn: "ব্যালকনি গার্ডেন সেটআপ (বেসিক)", price: 1499 }],
    extraNote: "Plants, pots, soil etc. at extra charges.",
    extraNoteBn: "গাছ, টব, মাটি ইত্যাদি অতিরিক্ত চার্জে।",
    priceLabel: "From ₹1,499",
    priceLabelBn: "শুরু ₹১,৪৯৯",
  },
  {
    id: "terrace-garden",
    name: "Terrace Garden Setup",
    nameBn: "টেরেস গার্ডেন সেটআপ",
    desc: "Complete terrace garden design and setup for rooftops.",
    descBn: "ছাদের জন্য পুরো টেরেস বাগানের ডিজাইন ও সেটআপ।",
    price: 2999,
    image: "/assets/terrace-garden.png",
    packages: [{ label: "Terrace Garden Setup (Starting)", labelBn: "টেরেস গার্ডেন সেটআপ (শুরু)", price: 2999 }],
    extraNote: "Large terrace? We inspect first, then share a quotation.",
    extraNoteBn: "বড় টেরেস হলে আগে ইনসপেকশন, তারপর কোটেশন দেওয়া হয়।",
    priceLabel: "Starting ₹2,999",
    priceLabelBn: "শুরু ₹২,৯৯৯",
  },
];
